export default __webpack_public_path__ + "27463e1861f1247d27275bf15520a7bf.svg";